module.exports = __webpack_public_path__ + "static/media/dollar_coin_silver_h.fcaf7486.png";